document.addEventListener("DOMContentLoaded", function () {
  // =========================================================
  // Basic Accessibility Fixes
  // =========================================================
  document.querySelectorAll(".full-unstyled-link").forEach(function (el) {
    el.removeAttribute("aria-labelledby");
  });

  // =========================================================
  // Search Accessibility Fixes
  // =========================================================
  document.querySelectorAll("form.search").forEach(function (form, index) {
    const input = form.querySelector(".search__input.field__input");
    const label = form.querySelector(".field__label");

    if (!input || !label) return;

    const uniqueId = "Search-In-Template-" + index;

    input.id = uniqueId;
    input.removeAttribute("aria-label");
    input.removeAttribute("aria-labelledby");
    input.removeAttribute("aria-describedby");

    label.setAttribute("for", uniqueId);
    label.removeAttribute("id");
  });

  // =========================================================
  // Cart Popup Accessibility Fixes
  // =========================================================
  const cartPopup = document.getElementById("cart-notification");
  const cartOpeners = document.querySelectorAll(
    "[data-cart-notification-open], .btn-cta-primary"
  );

  if (cartPopup && cartOpeners.length) {
    const closeButton = cartPopup.querySelector(".cart-btn-close");
    const continueButton = cartPopup.querySelector(
      ".cart-notification__links button"
    );

    let lastFocusedElement = null;

    cartOpeners.forEach(function (opener) {
      opener.setAttribute("aria-haspopup", "dialog");
      opener.setAttribute("aria-controls", "cart-notification");
      opener.setAttribute("aria-expanded", "false");

      opener.addEventListener(
        "click",
        function () {
          lastFocusedElement = opener;

          setTimeout(function () {
            if (cartPopup.classList.contains("active")) {
              opener.setAttribute("aria-expanded", "true");
              moveFocusToCartPopup();
            }
          }, 600);
        },
        true
      );

      opener.addEventListener(
        "keydown",
        function (event) {
          if (event.key === "Enter" || event.key === " ") {
            lastFocusedElement = opener;

            setTimeout(function () {
              if (cartPopup.classList.contains("active")) {
                opener.setAttribute("aria-expanded", "true");
                moveFocusToCartPopup();
              }
            }, 600);
          }
        },
        true
      );
    });

    function moveFocusToCartPopup() {
      const firstFocusable = cartPopup.querySelector(
        '.cart-btn-close, button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );

      if (firstFocusable) {
        firstFocusable.focus();
      } else {
        if (!cartPopup.hasAttribute("tabindex")) {
          cartPopup.setAttribute("tabindex", "-1");
        }

        cartPopup.focus();
      }
    }

    function closeCartPopup() {
      cartPopup.classList.remove("active");

      cartOpeners.forEach(function (opener) {
        opener.setAttribute("aria-expanded", "false");
      });

      setTimeout(function () {
        if (
          lastFocusedElement &&
          document.body.contains(lastFocusedElement) &&
          typeof lastFocusedElement.focus === "function"
        ) {
          lastFocusedElement.focus();
        }
      }, 150);
    }

    if (closeButton) {
      closeButton.addEventListener("click", function () {
        closeCartPopup();
      });
    }

    if (continueButton) {
      continueButton.addEventListener("click", function () {
        closeCartPopup();
      });
    }

    document.addEventListener("keydown", function (event) {
      if (
        event.key === "Escape" &&
        cartPopup.classList.contains("active")
      ) {
        event.preventDefault();
        closeCartPopup();
      }
    });
  }

  // =========================================================
  // External Links Accessibility Fixes
  // =========================================================
  const excludedLinks = [];

  function isThirdPartyLink(url) {
    try {
      const linkUrl = new URL(url, window.location.origin);

      if (
        ["mailto:", "tel:", "javascript:"].includes(linkUrl.protocol) ||
        url.startsWith("#")
      ) {
        return false;
      }

      return linkUrl.hostname !== window.location.hostname;
    } catch (error) {
      return false;
    }
  }

  document.querySelectorAll("a[href]").forEach(function (link) {
    const href = link.getAttribute("href");

    if (
      !href ||
      excludedLinks.includes(href) ||
      !isThirdPartyLink(href)
    ) {
      return;
    }

    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noopener noreferrer");

    const existingLabel = link.getAttribute("aria-label");
    const visibleText = link.textContent.trim().replace(/\s+/g, " ");
    const linkText = existingLabel || visibleText;

    if (linkText) {
      link.setAttribute(
        "aria-label",
        linkText +
          " Redirecting to a third-party website, opens in a new tab"
      );
    }

    const img = link.querySelector("img");

    if (img) {
      const alt = img.getAttribute("alt");

      if (alt && alt.trim()) {
        img.setAttribute(
          "alt",
          alt.trim() +
            " Redirecting to a third-party website, opens in a new tab"
        );
      }
    }
  });

  // =========================================================
  // Mega Menu Accessibility Fixes
  // =========================================================
  const megaMenuSummaries = document.querySelectorAll(
    "details.mega-menu > summary"
  );

  megaMenuSummaries.forEach(function (summary) {
    const details = summary.closest("details");

    if (!details) return;

    summary.setAttribute("role", "button");
    summary.setAttribute("tabindex", "0");
    summary.setAttribute(
      "aria-expanded",
      details.open ? "true" : "false"
    );

    const innerLinks = summary.querySelectorAll("a");

    innerLinks.forEach(function (link) {
      link.setAttribute("tabindex", "-1");
      link.setAttribute("aria-hidden", "true");
    });

    summary.addEventListener("keydown", function (event) {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();

        details.open = !details.open;

        summary.setAttribute(
          "aria-expanded",
          details.open ? "true" : "false"
        );
      }

      if (event.key === "Escape") {
        event.preventDefault();

        details.open = false;
        summary.setAttribute("aria-expanded", "false");
        summary.focus();
      }
    });

    summary.addEventListener("click", function () {
      setTimeout(function () {
        summary.setAttribute(
          "aria-expanded",
          details.open ? "true" : "false"
        );
      }, 0);
    });

    details.addEventListener("toggle", function () {
      summary.setAttribute(
        "aria-expanded",
        details.open ? "true" : "false"
      );
    });
  });

  // =========================================================
  // New Arrivals Card Accessible Labels
  // =========================================================
  document
    .querySelectorAll(".new-arrivals__card-info")
    .forEach(function (card) {
      const heading = card.querySelector(".new-arrivals__card-title");
      const link = card.querySelector("a");

      if (!heading || !link) return;

      const anchorText = link.textContent.trim().replace(/\s+/g, " ");
      const headingText = heading.textContent.trim().replace(/\s+/g, " ");

      if (!anchorText || !headingText) return;

      link.setAttribute(
        "aria-label",
        anchorText + " " + headingText
      );
    });

  // =========================================================
  // Banner Accessible Labels
  // =========================================================
  document.querySelectorAll(".banner__box").forEach(function (banner) {
    const heading = banner.querySelector(".banner__heading");
    const links = banner.querySelectorAll(".banner__buttons a");

    if (!heading || !links.length) return;

    const headingText = heading.textContent
      .trim()
      .replace(/\s+/g, " ");

    if (!headingText) return;

    links.forEach(function (link) {
      const anchorText = link.textContent
        .trim()
        .replace(/\s+/g, " ");

      if (!anchorText) return;

      link.setAttribute(
        "aria-label",
        anchorText + " " + headingText
      );
    });
  });

  // =========================================================
  // Guarantee Image Alternative Text
  // =========================================================
  const guaranteeImage = document.querySelector(
    'img[src*="guarantee_430x.webp"]'
  );

  if (guaranteeImage) {
    guaranteeImage.alt = "100 Percent Money Back Guarantee";
  }

  // =========================================================
  // Discover Silverts Dropdown Accessibility
  // =========================================================
  const navbar = document.querySelector(".page-navbar");

  if (navbar) {
    const dropdownSubmenus = navbar.querySelectorAll(
      ":scope > li > a + ul"
    );

    dropdownSubmenus.forEach(function (submenu, index) {
      const parentLi = submenu.parentElement;
      const trigger = parentLi
        ? parentLi.querySelector(":scope > a")
        : null;

      if (!parentLi || !trigger) return;

      const submenuId = "page-navbar-submenu-" + (index + 1);

      submenu.id = submenuId;

      trigger.setAttribute("aria-haspopup", "true");
      trigger.setAttribute("aria-expanded", "false");
      trigger.setAttribute("role", "button");
      trigger.setAttribute("tabindex", "0");
      trigger.setAttribute("aria-controls", submenuId);

      submenu.hidden = true;

      const svgIcon = trigger.querySelector("svg");

      if (svgIcon) {
        svgIcon.setAttribute("aria-hidden", "true");
        svgIcon.setAttribute("focusable", "false");
      }

      trigger.addEventListener("click", function (event) {
        event.preventDefault();

        const isOpen =
          trigger.getAttribute("aria-expanded") === "true";

        closeAllNavbarDropdowns();

        if (!isOpen) {
          openNavbarDropdown(trigger, submenu);
        }
      });

      trigger.addEventListener("keydown", function (event) {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          trigger.click();
        }

        if (event.key === "ArrowDown") {
          event.preventDefault();

          openNavbarDropdown(trigger, submenu);

          const firstSubmenuLink = submenu.querySelector("a");

          if (firstSubmenuLink) {
            firstSubmenuLink.focus();
          }
        }

        if (event.key === "Escape") {
          event.preventDefault();

          closeNavbarDropdown(trigger, submenu);
          trigger.focus();
        }
      });

      submenu.addEventListener("keydown", function (event) {
        const submenuLinks = Array.from(
          submenu.querySelectorAll("a")
        );

        if (!submenuLinks.length) return;

        const currentIndex = submenuLinks.indexOf(
          document.activeElement
        );

        if (event.key === "Escape") {
          event.preventDefault();

          closeNavbarDropdown(trigger, submenu);
          trigger.focus();
        }

        if (event.key === "ArrowDown") {
          event.preventDefault();

          const nextIndex =
            currentIndex < submenuLinks.length - 1
              ? currentIndex + 1
              : 0;

          submenuLinks[nextIndex].focus();
        }

        if (event.key === "ArrowUp") {
          event.preventDefault();

          const previousIndex =
            currentIndex > 0
              ? currentIndex - 1
              : submenuLinks.length - 1;

          submenuLinks[previousIndex].focus();
        }

        if (event.key === "Tab") {
          setTimeout(function () {
            if (!parentLi.contains(document.activeElement)) {
              closeNavbarDropdown(trigger, submenu);
            }
          }, 0);
        }
      });
    });

    document.addEventListener("click", function (event) {
      if (!navbar.contains(event.target)) {
        closeAllNavbarDropdowns();
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        closeAllNavbarDropdowns();
      }
    });

    function openNavbarDropdown(trigger, submenu) {
      trigger.setAttribute("aria-expanded", "true");
      submenu.hidden = false;
    }

    function closeNavbarDropdown(trigger, submenu) {
      trigger.setAttribute("aria-expanded", "false");
      submenu.hidden = true;
    }

    function closeAllNavbarDropdowns() {
      navbar
        .querySelectorAll(":scope > li > a[aria-expanded]")
        .forEach(function (trigger) {
          const submenuId = trigger.getAttribute("aria-controls");
          const submenu = submenuId
            ? document.getElementById(submenuId)
            : null;

          if (submenu) {
            closeNavbarDropdown(trigger, submenu);
          }
        });
    }
  }

  // =========================================================
  // Convert Navigation Element to Div
  // =========================================================
  document
    .querySelectorAll(".info-navbar nav.header__inline-menu")
    .forEach(function (nav) {
      const div = document.createElement("div");

      Array.from(nav.attributes).forEach(function (attribute) {
        div.setAttribute(attribute.name, attribute.value);
      });

      while (nav.firstChild) {
        div.appendChild(nav.firstChild);
      }

      if (nav.parentNode) {
        nav.parentNode.replaceChild(div, nav);
      }
    });

  // =========================================================
  // Tabs and Tabpanels Accessibility Fixes
  // =========================================================
document.querySelectorAll(".worko-tabs").forEach(function (component) {
  const tabsContainer = component.querySelector(
    ".tabs.flex-tabs.hidden-md-down"
  );

  if (!tabsContainer) return;

  /*
   * Prevent the script from running more than once
   */
  if (tabsContainer.dataset.accessibilityTabsInitialized === "true") {
    return;
  }

  tabsContainer.dataset.accessibilityTabsInitialized = "true";

  /*
   * Get ONLY the direct tab labels.
   * Panels are intentionally excluded.
   */
  const tabs = Array.from(
    tabsContainer.querySelectorAll(":scope > label.tab")
  );

  if (!tabs.length) return;

  /*
   * The original .tabs container must NOT have role="tablist"
   * because it also contains the tabpanels.
   */
  tabsContainer.removeAttribute("role");

  /*
   * Create a separate tablist.
   * This element will contain ONLY role="tab" elements.
   */
  const tabList = document.createElement("div");

  tabList.className = "accessible-tablist";
  tabList.setAttribute("role", "tablist");
  tabList.setAttribute(
    "aria-label",
    "Product information"
  );

  /*
   * Insert the new tablist at the beginning
   * of the existing tabs container.
   */
  tabsContainer.insertBefore(
    tabList,
    tabsContainer.firstChild
  );

  /*
   * Move ONLY the tab labels into the tablist.
   *
   * The tabpanels remain inside the original
   * .tabs container, so the existing CSS/layout
   * continues to work.
   */
  tabs.forEach(function (tab) {
    tabList.appendChild(tab);
  });

  /*
   * Configure every tab.
   */
  tabs.forEach(function (tab, index) {
    const inputId = tab.getAttribute("for");

    if (!inputId) return;

    const input = component.querySelector(
      "#" + CSS.escape(inputId)
    );

    const panel = component.querySelector(
      "#" + CSS.escape(inputId + "-panel")
    );

    /*
     * Give the tab a unique ID.
     */
    if (!tab.id) {
      tab.id = inputId + "-tab";
    }

    /*
     * Store associated input.
     */
    tab.dataset.targetInput = inputId;

    /*
     * Remove "for" because the label is now
     * functioning as an ARIA tab.
     */
    tab.removeAttribute("for");

    /*
     * ARIA tab attributes.
     */
    tab.setAttribute("role", "tab");

    tab.setAttribute(
      "tabindex",
      index === 0 ? "0" : "-1"
    );

    tab.setAttribute(
      "aria-selected",
      index === 0 ? "true" : "false"
    );

    if (panel) {
      tab.setAttribute(
        "aria-controls",
        panel.id
      );
    }

    /*
     * Hide the original radio input from
     * screen readers and keyboard navigation.
     */
    if (input) {
      input.setAttribute(
        "aria-hidden",
        "true"
      );

      input.setAttribute(
        "tabindex",
        "-1"
      );

      input.setAttribute(
        "role",
        "presentation"
      );
    }

    /*
     * Configure the tabpanel.
     */
    if (panel) {
      panel.setAttribute(
        "role",
        "tabpanel"
      );

      panel.setAttribute(
        "aria-labelledby",
        tab.id
      );

      /*
       * Keep the first panel visible.
       */
      if (index === 0) {
        panel.hidden = false;
        panel.classList.add("active");
      } else {
        panel.hidden = true;
        panel.classList.remove("active");
      }
    }

    /*
     * Mouse / pointer activation.
     */
    tab.addEventListener(
      "click",
      function (event) {
        event.preventDefault();

        activateAccessibleTab(
          tab,
          tabs,
          component
        );
      }
    );

    /*
     * Keyboard support.
     */
    tab.addEventListener(
      "keydown",
      function (event) {
        const currentIndex =
          tabs.indexOf(tab);

        let newIndex = currentIndex;

        switch (event.key) {
          case "ArrowRight":
          case "ArrowDown":
            newIndex =
              (currentIndex + 1) %
              tabs.length;
            break;

          case "ArrowLeft":
          case "ArrowUp":
            newIndex =
              (currentIndex - 1 + tabs.length) %
              tabs.length;
            break;

          case "Home":
            newIndex = 0;
            break;

          case "End":
            newIndex =
              tabs.length - 1;
            break;

          case "Enter":
          case " ":
            event.preventDefault();

            activateAccessibleTab(
              tab,
              tabs,
              component
            );

            return;

          default:
            return;
        }

        event.preventDefault();

        tabs[newIndex].focus();

        activateAccessibleTab(
          tabs[newIndex],
          tabs,
          component
        );
      }
    );
  });

  /*
   * Activate the first tab on page load.
   */
  activateAccessibleTab(
    tabs[0],
    tabs,
    component
  );
});


function activateAccessibleTab(
  activeTab,
  tabs,
  component
) {
  tabs.forEach(function (tab) {
    const inputId =
      tab.dataset.targetInput;

    if (!inputId) return;

    const input = component.querySelector(
      "#" + CSS.escape(inputId)
    );

    const panel = component.querySelector(
      "#" + CSS.escape(inputId + "-panel")
    );

    const isActive =
      tab === activeTab;

    /*
     * Update aria-selected.
     */
    tab.setAttribute(
      "aria-selected",
      isActive ? "true" : "false"
    );

    /*
     * Roving tabindex.
     */
    tab.setAttribute(
      "tabindex",
      isActive ? "0" : "-1"
    );

    /*
     * Remove previously generated
     * "selected" text.
     */
    tab.querySelectorAll(
      ".tab-selected-text"
    ).forEach(function (element) {
      element.remove();
    });

    /*
     * Add screen-reader-only selected text.
     */
    if (isActive) {
      const selectedText =
        document.createElement("span");

      selectedText.className =
        "visually-hidden tab-selected-text";

      selectedText.textContent =
        " selected";

      tab.appendChild(
        selectedText
      );
    }

    /*
     * Keep the original radio input
     * synchronized with the active tab.
     */
    if (input) {
      input.checked = isActive;
    }

    /*
     * Show / hide the correct panel.
     */
    if (panel) {
      panel.hidden = !isActive;

      panel.classList.toggle(
        "active",
        isActive
      );
    }
  });
}

  // =========================================================
  // Collection Variant Color Swatches Accessibility
  // =========================================================
  document.querySelectorAll(".color-swatches").forEach(function (
    oldWrapper
  ) {
    const ul = document.createElement("ul");

    Array.from(oldWrapper.attributes).forEach(function (attribute) {
      ul.setAttribute(attribute.name, attribute.value);
    });

    ul.setAttribute("aria-label", "Product variant colors");

    const swatches = Array.from(
      oldWrapper.querySelectorAll(".swatch_container")
    );

    const expandButton = oldWrapper.querySelector(
      ".expand-swatches"
    );

    swatches.forEach(function (swatch) {
      const li = document.createElement("li");

      li.className = swatch.className;

      const input = swatch.querySelector("input");
      const labelSpan = swatch.querySelector("label span");

      const labelText =
        (input && input.getAttribute("data-color")) ||
        (input && input.value) ||
        (labelSpan && labelSpan.textContent.trim()) ||
        "Product variant";

      const hiddenText = document.createElement("span");

      hiddenText.className = "visually-hidden";
      hiddenText.textContent =
        "Product variant: " + labelText;

      li.appendChild(hiddenText);

      while (swatch.firstChild) {
        li.appendChild(swatch.firstChild);
      }

      ul.appendChild(li);
    });

    if (expandButton) {
      const expandItem = document.createElement("li");

      expandItem.className = "expand-swatches-item";
      expandItem.appendChild(expandButton);
      ul.appendChild(expandItem);
    }

    oldWrapper.replaceWith(ul);
  });

  // =========================================================
  // Convert Progress Bar h4 Elements to h2
  // =========================================================
  document
    .querySelectorAll("h4.progress-bar-title")
    .forEach(function (h4) {
      const h2 = document.createElement("h2");

      Array.from(h4.attributes).forEach(function (attribute) {
        h2.setAttribute(attribute.name, attribute.value);
      });

      h2.innerHTML = h4.innerHTML;
      h4.replaceWith(h2);
    });

  // =========================================================
  // Clothing Type Card Accessible Labels
  // =========================================================
  document
    .querySelectorAll(".clothing-type__card")
    .forEach(function (card) {
      const heading = card.querySelector(
        ".clothing-type__card-title"
      );

      if (!heading) return;

      const headingText = heading.textContent
        .trim()
        .replace(/\s+/g, " ");

      if (!headingText) return;

      card
        .querySelectorAll(".clothing-type__card-info a")
        .forEach(function (link) {
          const linkText = link.textContent
            .trim()
            .replace(/\s+/g, " ");

          if (!linkText) return;

          link.setAttribute(
            "aria-label",
            linkText + ", " + headingText
          );
        });
    });
});

// Shop Now Label Dynamically
document.addEventListener("DOMContentLoaded", () => {
  const heading = document.querySelector(".shop-bar__link.hidden-md-down strong");
  const button = document.querySelector(".shop-bar__button");

  if (heading && button) {
    const buttonText = button.textContent.trim();
    const headingText = heading.textContent.trim();

    button.setAttribute("aria-label", `${buttonText}, ${headingText}`);
    button.setAttribute("title", `${buttonText}, ${headingText}`);
  }
});

// Search Suggestions Accessibility Fixes
document.addEventListener("keydown", function (event) {
  if (event.key !== "Escape") return;

  const predictiveSearch = document.querySelector("predictive-search[open]");
  const searchInput = document.querySelector(
    '.search__input[aria-expanded="true"]'
  );

  if (!predictiveSearch || !searchInput) return;

  // Hide the predictive search
  predictiveSearch.removeAttribute("open");
  predictiveSearch.removeAttribute("results");

  // Update accessibility attributes
  searchInput.setAttribute("aria-expanded", "false");

  // Hide the results container
  const results = predictiveSearch.querySelector(
    ".predictive-search[data-predictive-search]"
  );

  if (results) {
    results.innerHTML = "";
    results.style.display = "none";
  }

  // Return focus to the search input
  searchInput.focus();
});

// adding labels
document.querySelectorAll(".collection-header").forEach((section) => {
  const heading = section.querySelector("h2");
  const link = section.querySelector("a");

  if (heading && link) {
    const headingText = heading.textContent.trim();
    const linkText = link.textContent.trim();

    link.setAttribute("aria-label", `${linkText}, ${headingText}`);
  }
});

// img first aria-hidden 
document.addEventListener("DOMContentLoaded", function () {
  const firstImage = document.querySelector(
    ".media.media--transparent.media--hover-effect img:first-of-type"
  );

  if (firstImage) {
    firstImage.setAttribute("aria-hidden", "true");
  }
});

// Click Here
document.addEventListener("DOMContentLoaded", function () {
  const shippingLink = [...document.querySelectorAll('a[href="/pages/shipping-policy"]')]
    .find(link => link.textContent.trim() === "click here");

  if (shippingLink) {
    shippingLink.setAttribute("aria-label", "Click here, Shipping Policy");
  }
});

// aria-hidden on br
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("br").forEach(function (br) {
    br.setAttribute("aria-hidden", "true");
  });
});

// Plain text to link for disable users
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("body *").forEach(function (element) {
    if (element.children.length) return;

    element.innerHTML = element.innerHTML
      .replace(/1-800-387-7088/g, '<a href="tel:+18003877088">1-800-387-7088</a>')
      .replace(/905-738-4545/g, '<a href="tel:+19057384545">905-738-4545</a>')
      .replace(/905-738-6236/g, '<a href="tel:+19057386236">905-738-6236</a>');
  });
});

// adding aria-hidden attribute on the SVGs 
document.addEventListener('DOMContentLoaded', function () {
  $('.confidence__item svg').attr('aria-hidden', 'true');
});

// adding label
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.shop-bar-partnership').forEach(function (bar) {
    const button = bar.querySelector('.shop-bar__button');
    const link = bar.querySelector('.shop-bar__link');

    if (button && link) {
      const text = link.textContent.replace(/\s+/g, ' ').trim();
      const match = text.match(/Learn more about (.+)/i);

      if (match) {
        const accessibleLabel = 'Learn more about ' + match[1];

        button.setAttribute('aria-label', accessibleLabel);
        button.setAttribute('title', accessibleLabel);
      }
    }
  });
});

// Adding accessible labels for view all
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a').forEach(function (link) {
    const linkText = link.textContent.trim();

    if (linkText.toLowerCase() === 'view all') {
      const section = link.closest('section');

      if (section) {
        const heading = section.querySelector('h1, h2, h3, h4, h5, h6');

        if (heading) {
          const headingText = heading.textContent.replace(/\s+/g, ' ').trim();
          const accessibleLabel = 'View all ' + headingText;

          link.setAttribute('aria-label', accessibleLabel);
          link.setAttribute('title', accessibleLabel);
        }
      }
    }
  });
});

// Convert to button
document.addEventListener('DOMContentLoaded', function () {
  document
    .querySelectorAll('span.instant-video__button.instant-vimeo__button')
    .forEach(function (element) {
      element.setAttribute('role', 'button');
      element.setAttribute('tabindex', '0');
    });
});

// Empty h3 removing
document.addEventListener('DOMContentLoaded', function () {
  var emptyHeadings = document.querySelectorAll(
    '[data-instant-type="text"] h3'
  );

  emptyHeadings.forEach(function (heading) {
    if (heading.textContent.trim() === '') {
      heading.remove();
    }
  });
});